export default function (buttonId, checkboxId) {
    const submitBtn = document.getElementById(buttonId);
    const checkbox = document.getElementById(checkboxId);

    if (!submitBtn || !checkbox) {
        return;
    }

    const toggle = () => {
        if (checkbox.checked) {
            submitBtn.removeAttribute('disabled');
        } else {
            submitBtn.setAttribute('disabled', '');
        }
    };
    toggle();
    checkbox.onclick = toggle;
}



// WEBPACK FOOTER //
// ./src/utils/toggleSubmit.js